import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { orange1 } from 'approot/shared/styles/colours.style';
import { spacing16 } from 'approot/shared/styles/spacing.style';

export const ContentPageArchivedBanner = styled.div`
  background-color: ${orange1};
  padding: ${rem(spacing16)};
  text-align: center;
`;
